import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  API,
  Field2 as Field,
  SidePanelFooter,
  VibeButton,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';
import './RequestChanges.scss';

class RequestChanges extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      changes: '',
    };
  }

  onChange = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    this.setState({
      changes: value,
    });
  };

  onSave = async () => {
    const {
      messageId,
      onClose,
    } = this.props;

    const {
      changes,
    } = this.state;

    await API.MessageRequest.requestChanges(messageId, {
      _id: messageId,
      response: 'request-change',
      comment: changes,
    });

    onClose();
  };

  render() {
    const {
      onClose,
    } = this.props;

    const {
      changes,
    } = this.state;

    return (
      <div className="RequestChanges">
        <div className="header">
          <div className="title">
            Request Changes
          </div>

          <VibeIcon
            className="close"
            icon={viClose}
            color={color.manatee}
            hoverColor={color.obsidian}
            size={24}
            onClick={onClose}
          />
        </div>

        <div className="content">
          <Field
            className="changes-textarea"
            type="textarea"
            placeholder="Let us know what needs changed here."
            value={changes}
            autoFocus
            onChange={this.onChange}
          />
        </div>

        <SidePanelFooter>
          <VibeButton
            text="Send Request"
            btnColor="flamingo"
            textColor="white"
            disabled={!changes}
            onClick={this.onSave}
          />

          <VibeButton
            className="cancel-button"
            text="Cancel"
            btnColor="transparent"
            textColor="manatee"
            onClick={onClose}
          />
        </SidePanelFooter>
      </div>
    );
  }
}

RequestChanges.propTypes = {
  messageId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

RequestChanges.defaultProps = {
  onClose: () => {},
};

export default RequestChanges;
